// Load HLS.js dynamically if not already present
function loadHlsJs(callback) {
  if (window.Hls) return callback();
  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/hls.js@latest';
  script.onload = callback;
  document.head.appendChild(script);
}

function initVideo(video) {
  const hlsSource = video.querySelector('source[type="application/x-mpegURL"]');
  const mp4Source = video.querySelector('source[type="video/mp4"]');

  if (hlsSource && hlsSource.dataset.src) {
    loadHlsJs(() => {
      if (Hls.isSupported()) {
        // Chrome, Firefox etc: gebruik HLS.js
        const hls = new Hls({ autoStartLoad: true });
        hls.loadSource(hlsSource.dataset.src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play().catch(() => {});
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Safari: native HLS
        video.src = hlsSource.dataset.src;
        video.load();
        video.play().catch(() => {});
      } else if (mp4Source && mp4Source.dataset.src) {
        // Fallback: MP4
        video.src = mp4Source.dataset.src;
        video.load();
        video.play().catch(() => {});
      }
    });
  } else if (mp4Source && mp4Source.dataset.src) {
    // Geen HLS beschikbaar, gebruik MP4
    video.src = mp4Source.dataset.src;
    video.load();
    video.play().catch(() => {});
  }
}

if (typeof VideoBackgroundElement !== 'function') {

  class VideoBackgroundElement extends HTMLElement {

    constructor() {
      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');

      video.addEventListener('error', e => {
        this.switchFallback();
      });

      video.addEventListener('playing', e => {
        if (!this.classList.contains('loaded')) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      });

      video.addEventListener('stalled', e => {
        if (!this.classList.contains('loaded')) {
          this.switchFallback();
        }
      });

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if (
          (entries[0].target.querySelector('video-background-element') &&
            !entries[0].target.querySelector('video-background-element').classList.contains('loaded')) ||
          (entries[0].tagName == 'video-background-element' && !entries[0].target.classList.contains('loaded'))
        ) {
          initVideo(video);
        }
        observer.unobserve(this);
      };

      if (
        this.getBoundingClientRect().y < window.innerHeight ||
        this.parentNode.getBoundingClientRect().y < window.innerHeight
      ) {
        initVideo(video);
      } else {
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.parentElement);
      }
    }

    switchFallback() {
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if (fallback) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }
  }

  if (typeof customElements.get('video-background-element') == 'undefined') {
    customElements.define('video-background-element', VideoBackgroundElement);
  }
}

document.addEventListener('shopify:section:load', e => {
  if (e.target.classList.contains('mount-video-background') || e.target.classList.contains('mount-vertical-slideshow')) {
    setTimeout(() => {
      e.target.querySelectorAll('video-background-element').forEach(elm => {
        initVideo(elm.querySelector('video'));
      });
    }, 500);
  }
});

// Safari autoplay workaround: start alle videos bij eerste gebruikersinteractie
document.addEventListener('click', () => {
  document.querySelectorAll('video').forEach(v => {
    if (v.paused) v.play().catch(() => {});
  });
}, { once: true });

document.addEventListener('touchstart', () => {
  document.querySelectorAll('video').forEach(v => {
    if (v.paused) v.play().catch(() => {});
  });
}, { once: true });